// extracted by mini-css-extract-plugin
export default {"pgButton":"styles_pgButton__u9y3Z","pgButtonActive":"styles_pgButtonActive__1WqMt","center":"styles_center__AvDac"};